<script setup lang="ts">
import {
  showEditChatTitleDialogue,
  editForm,
} from "@/components/Dialogues/useData/useDialogues";
import {
  dialogueList,
  renameDialogue,
} from "@/views/Home/useData/module/dialogue";
const endEdit = () => {
  showEditChatTitleDialogue.value = false;

  renameDialogue(editForm.index, editForm.content);
};
</script>

<template>
  <el-dialog
    v-model="showEditChatTitleDialogue"
    width="260"
    class="custom"
    align-center
    center
    :show-close="false"
    :style="{ '--el-border-radius-base': '16px' }"
  >
    <template v-slot:header> </template>
    <div class="content">
      <div class="title">修改对话名称</div>
      <input
        placeholder="请输入对话名称"
        maxlength="20"
        class="input-content"
        type="text"
        name=""
        id=""
        v-model="editForm.content"
      />
    </div>
    <template v-slot:footer>
      <div class="footer">
        <el-button
          class="cancel-btn"
          @click="showEditChatTitleDialogue = false"
          type=""
          >取消
        </el-button>

        <el-button class="ok-btn" type="primary" @click="endEdit"
          >确定</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.custom {
  :deep(.el-dialog__header) {
    display: none !important;
  }
  .el-dialog__header {
    display: none !important;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .input-content {
      padding: 0 10px;
      border-radius: 8px;
      outline: none;
      border: none;
      background: #eeeeee;
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }

  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .cancel-btn {
      width: 50%;
      color: #4d6bfe;
      border-radius: 8px;
    }
    .ok-btn {
      border-radius: 8px;
      border: 0px solid #4d6bfe;
      width: 50%;
      color: #fff;
      background-color: #4d6bfe;

      &:hover {
        background-color: #4d6bfe99;
      }
    }
  }
}
</style>
